import {AboutBlock, CommunityBlock, HeaderBlock, NewsBlock} from '../../components/homeV2';
import {AppConfigStore, BlogStore, HeaderStore, HomeStore, LoginStore, SubscriptionStore} from '../../stores';

import { BlogActions } from 'epic-minimalist-blog/app/scripts/actions';
import PropTypes from 'prop-types';
import React from 'react';
import {connectToStores} from 'epic-alt-utils';
import {withRouter} from 'react-router';

/**
 * HomePage View.
 */
@connectToStores
class HomeView extends React.Component {
    static getStores() {
        return [HomeStore, SubscriptionStore, HeaderStore, BlogStore, AppConfigStore, LoginStore];
    }

    static getPropsFromStores() {
        return {
            subscriptionStore: SubscriptionStore.getState(),
            homeStore: HomeStore.getState(),
            blogStore: BlogStore.getState(),
            loginStore: LoginStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            mobile: HeaderStore.getState().mobile(),
            tablet: HeaderStore.getState().tablet()
        };
    }

    static getInitialActions() {
        return [
            (props) => {
                // reset blog store state so it won't read state from news page
                BlogActions.setStoreState({
                    blogList: []
                });
                BlogActions.getBlogData({
                    category: 'all',
                    rootPageSlug: HomeView.defaultProps.rootPageSlug,
                    initCount: props.postsPerPage
                });
            }
        ];
    }

    static defaultProps = {
        routerRootUrl: 'news',
        rootPageSlug: 'blog',
        enableTileChunking: true,
        enableAutoShortDescription: false,
        hideLoadIndicator: false,
        mobilePostNum: 2
    };

    static propTypes = {
        homeStore: PropTypes.object,
        subscriptionStore: PropTypes.object,
        blogStore: PropTypes.object,
        loginStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool
    };

    render() {
        const CMSData = this.props.homeStore.cmsData;
        const {isSubscribed} = this.props.subscriptionStore;
        const {homepage} = CMSData;
        const {header, about, community, news} = homepage;
        const {isLoggedIn} = this.props.loginStore;
        const {launchedCountries} = this.props.appConfigStore;
        const {appStoreImg} = launchedCountries;
        const isGameLaunched = this.props.appConfigStore.checkGameLaunched();
        return (
            <div className="homePage">
                <HeaderBlock
                    {...this.props}
                    data={header}
                    isGameLaunched={isGameLaunched}
                    appImage={appStoreImg}
                    isLoggedIn={isLoggedIn}
                    isSubscribed={isSubscribed}
                    mobile={this.props.mobile} />
                <AboutBlock data={about} mobile={this.props.mobile} />
                <NewsBlock 
                    data={this.props.blogStore}
                    cmsData={news}
                    isGameLaunched={isGameLaunched}
                    appImage={appStoreImg}
                    ctaString={header.cta}
                    isSubscribed={isSubscribed}
                    isLoggedIn={isSubscribed}
                    mobilePostNum={2} 
                    {...this.props} />
                <CommunityBlock data={community} />
            </div>
        );
    }
}

export default withRouter(HomeView);
